import { Component, Inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { IconImageService } from "@shared/services/icon-image.service"

@Component({
  selector: "app-bigger-image-dialog",
  standalone: false,
  templateUrl: "./bigger-image-dialog.component.html",
  styleUrl: "./bigger-image-dialog.component.scss",
})
export class BiggerImageDialogComponent {
  public imgSrc: string = ""

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<BiggerImageDialogComponent>, public iconService: IconImageService) {
    this.imgSrc = data.imgSrc
  }

  close() {
    this.dialogRef.close(false)
  }
}
